export default function () {
	//Pro tento konkrétní, zatím ojedinělý případ (https://coweo.myjetbrains.com/youtrack/issue/JP-4722/JenFirmy.cz-premiovy-profil-modal) řešeno takto.
	//Pokud by se další formuláře na jenFirmy řešili, ne přes react, ale standardní cestou, zvážit použití Naja a nette forms
	document.querySelector('#addPremiumProfile')?.addEventListener('submit', function (event) {
		event.preventDefault(); // Zabráníme standardnímu odeslání formuláře

		const formData = new FormData(this);
		const submitButton = event.target.querySelector('button[type="submit"]');
		const url = submitButton.getAttribute('data-link');
		fetch(url, {
			method: 'POST',
			body: formData
		})
			.then((response) => response.json())
			.then((data) => {
				const successDiv = event.target.querySelector('.success');
				const errorDiv = event.target.querySelector('.invalid-feedback');
				if (data.success) {
					gtmSuccess();
					event.target.querySelector('.form-group').classList.add('d-none');
					event.target.querySelector('.button-cont').classList.add('d-none');
					errorDiv.classList.remove('d-block');
					successDiv.textContent = data.success;
					const modalElement = document.getElementById('modalAddPremiumPopUp');
					setTimeout(() => {
						let myModal = Modal.getInstance(modalElement);
						myModal.hide();
					}, 3000);
				} else if (data.error) {
					errorDiv.textContent = data.error;
					errorDiv.classList.add('d-block');
				}
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

	document.querySelector('#modalAddPremiumPopUp')?.addEventListener('hide.bs.modal',function(e){
		if(e.target instanceof Element){
			let modal = e.target;
			if (modal.getAttribute("data-success") !== "1") {
				///modal se zavira aniz by doslo k uspesnemu odeslani
				gtmNoSuccess();
			}
		}
	});

	function gtmSuccess(){
		///JP-5369
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({event: 'zavolat-zpatky-premium',success: 'uspesne-odeslal'});
		document.querySelector('#modalAddPremiumPopUp')?.setAttribute("data-success", "1");
	}

	function gtmNoSuccess(){
		///JP-5369
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({event: 'zavolat-zpatky-premium',success: 'neodeslal'});
	}
}
